import React, { Component } from "react";
import Header from "../../common/components/Header";
import FooterComponent from "../../common/components/Footer";
import { withRouter } from "react-router";
import UpgradePlanComponent from "../../components/pages/subscription/upgradePlanComponent";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import "./shopifySetupBanner.css";

class ContentWrapper extends Component {
    constructor(props) {
        super(props);
    this.state = {
      isShopifyEnabled:
        window.sessionStorage.getItem("isShopifyEnabled") === "true",
      isShopifyVerified:
        window.sessionStorage.getItem("isShopifyVerified") === "true",
    };
  }

  componentDidMount() {
    this.syncShopifyBannerFlags();
    this._storageListener = () => this.syncShopifyBannerFlags();
    window.addEventListener("storage", this._storageListener);
    this._flagPoll = setInterval(this.syncShopifyBannerFlags, 1500);
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this._storageListener);
    if (this._flagPoll) clearInterval(this._flagPoll);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location?.pathname !== this.props.location?.pathname) {
      this.syncShopifyBannerFlags();
    }
  }

  syncShopifyBannerFlags = () => {
    const isShopifyEnabled =
      window.sessionStorage.getItem("isShopifyEnabled") === "true";
    const isShopifyVerified =
      window.sessionStorage.getItem("isShopifyVerified") === "true";
    if (
      isShopifyEnabled !== this.state.isShopifyEnabled ||
      isShopifyVerified !== this.state.isShopifyVerified
    ) {
      this.setState({ isShopifyEnabled, isShopifyVerified });
    }
  };

  isProfilePage = () => {
    const path = (this.props.location?.pathname || "").toLowerCase();
    return path === "/profile" || path.endsWith("/myprofile");
  };

  handleCompleteSetup = () => {
    if (this.isProfilePage()) {
      window.dispatchEvent(new CustomEvent("watchops-scroll-shopify"));
      return;
    }
    this.props.history.push("/profile?scroll=shopify");
  };

  isAuthPage = () => {
    const path = (this.props.location?.pathname || "").toLowerCase();
    const authPaths = [
      "/login",
      "/register",
      "/sign-up",
      "/signup",
      "/forgot-password",
      "/forgot-otp",
      "/forgot-success",
      "/verify-otp",
      "/reset-password",
      "/set-password",
      "/mfa",
      "/mfa-verification",
      "/mfa-otp-verify",
      "/bussiness-detail",
      "/verify-email",
      "/confirm-email",
      "/email-verification",
    ];
    return authPaths.some(
      (p) => path === p || path.startsWith(`${p}/`),
    );
  };

    render() {
        if (this.props.location.pathname.includes("/administration")) {
            localStorage.setItem("menuTitle", "User Management");
        } else {
            localStorage.setItem("", "");
        }

    const showShopifyBanner =
      !this.isAuthPage() &&
      this.state.isShopifyEnabled &&
      !this.state.isShopifyVerified;

    const authShell = this.isAuthPage();

        return (
            <div 
              className={authShell ? "auth-shell" : undefined}
              style={{
                backgroundColor: authShell ? "#0a0a0a" : "white",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                ...(authShell
                  ? {
                      height: "100vh",
                      overflow: "hidden",
                    }
                  : {}),
              }}
            >
                <Header />
        {showShopifyBanner && (
          <div className="shopify-setup-banner">
            <div className="shopify-setup-banner-inner">
              <div className="shopify-setup-banner-left">
                <div className="shopify-setup-banner-icon-wrap">
                  <InfoOutlinedIcon className="shopify-setup-banner-icon" />
                </div>
                <div className="shopify-setup-banner-text">
                  <strong className="shopify-setup-banner-title">
                    Shopify setup incomplete
                  </strong>
                  <span className="shopify-setup-banner-desc">
                    Complete your Shopify setup to automatically sync your
                    products and inventory with your Shopify store.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="shopify-setup-banner-btn"
                onClick={this.handleCompleteSetup}
              >
                Complete Setup
              </button>
            </div>
          </div>
        )}
                <div
                    style={{
                      backgroundColor: "white",
                      flex: "1 1 auto",
                      minHeight: 0,
                      display: "flex",
                      flexDirection: "column",
                      ...(authShell
                        ? {
                            overflow: "hidden",
                          }
                        : {}),
                    }}
                >
                    {this.props.contentView || this.props.children}
                    {this.props.showSubscriptionPopup && (
                        <UpgradePlanComponent isOpen={this.props.showSubscriptionPopup} />
                    )}
                </div>
                <FooterComponent />
            </div>
        );
    }
}
export default withRouter(ContentWrapper);
